import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core'
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ModalService } from '@app/modal/modal.service'
import { TreeNode, TreeSearchComponent } from '../component/tree-search.component'
import { TreeSearchService } from '../service/tree-search.service'

@Component({
  selector: 'app-tree-search-dialog',
  templateUrl: './tree-search-dialog.component.html',
  styleUrls: ['./tree-search-dialog.component.scss'],
})
export class TreeSearchDialogComponent<T extends { id: number | string }>
  extends TreeSearchComponent<T>
  implements OnInit, OnDestroy {
  modal: MatDialogRef<any>

  @Input()
  outerTitle: string

  @Input()
  innerTitle: string

  @Input()
  fieldLabel?: string

  @Input()
  buttonLabel: string

  @Input()
  showPreview = true

  @Output()
  closedModal = new EventEmitter()

  constructor(private modalService: ModalService, treeService: TreeSearchService, private cdRef: ChangeDetectorRef) {
    super(treeService)
  }

  getSelectedMessage(node: TreeNode): string {
    const selected = node?.children.filter((child) => child.selected)
    if (selected.length == node?.children.length) {
      return 'Todas selecionadas'
    } else if (selected.length > 0) {
      return `${selected.length} selecionadas`
    } else {
      return 'Nenhuma selecionada'
    }
  }

  ngOnInit() {
    super.ngOnInit()
  }

  openModal(templateRef: TemplateRef<any>) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '54em'
    dialogConfig.height = `${this.height}em`
    dialogConfig.restoreFocus = false
    dialogConfig.panelClass = 'no-padding'
    dialogConfig.disableClose = true
    this.modal = this.modalService.openCustomComponentModal(templateRef, dialogConfig)
  }

  closeModal(event) {
    this.modal.close()
    this.closedModal.emit()
    this.cdRef.detectChanges()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  get parents() {
    return this.dataSource.data
  }
}
